import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// La app se carga siempre desde el servidor (envoltorio nativo Capacitor), así que
// NO queremos caché offline de PWA: el service worker servía versiones viejas y
// obligaba a borrar datos de la app tras cada despliegue. unregister() elimina
// cualquier service worker ya instalado en la siguiente carga.
serviceWorkerRegistration.unregister();
